import React from "react";
import './About.css';
function About(){

     return(
          <div className="about__section" id="about__us">
               <div className="about">
                    <div className="about__image">
                          <img src="../images/image3.png" alt=""/>
                   
                   
                   </div>
               
               </div>
               <div className="about__content">
                <h4>about us</h4>
                <div className="para__content">
                    <div className="imgs1">
                    
                         <img src="../images/Vector (34).png" alt=""/>


                   </div>
                     
                     <div className="para__div">
                          <h5>Take care of your pet</h5>
                          <small>Take care of your pet,never leave them sick and weak .we are here to help you treat your pets and help them grow.</small>
                     </div>
                </div>
                <div className="para__content">
                    <div className="imgs2">
                          <img src="../images/Vector (35).png" alt=""/>


                   </div>
                     <div className="para__div">
                          <h5>Take care of your pet</h5>
                          <small>Take care of your pet,never leave them sick and weak .we are here to help you treat your pets and help them grow.</small>
                     </div>
                </div>
                <div className="para__content">
                    <div className="imgs3">
                         <img src="../images/Vector (36).png"  alt=""/>


                   </div>
                     <div className="para__div">
                          <h5>Take care of your pet</h5>
                          <small>Take care of your pet,never leave them sick and weak .we are here to help you treat your pets and help them grow.</small>
                     </div>
                </div>
          </div>
              
               
               
          
          </div>
     )
}
export default About;